import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  showIcon?: boolean;
};
const baseClasses = 'inline-flex items-center justify-center gap-2.5 rounded-full bg-acad-goldDark px-7 py-3.5 text-sm font-bold uppercase tracking-[0.04em] text-white shadow-soft transition-colors duration-150 ease-out hover:bg-acad-ink focus:outline-none focus-visible:ring-4 focus-visible:ring-acad-gold/30 sm:px-8 sm:text-base';
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  showIcon = true,
  ...props
}: ButtonProps) {
  const content = <>
      {children}
      {showIcon && <ArrowRightIcon size={18} strokeWidth={2.2} aria-hidden="true" data-id="element-39" data-mp="30qqmgum74fj1" />}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} className={`${baseClasses} ${className}`} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} transition={{
      duration: 0.14,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-40" data-mp="2vy75ros7p4a0">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-41" data-mp="3qglif7dbvn1h">
      {content}
    </motion.button>;
}